
export class ResolvableService {
  private static ComponentsStore: Map<string, any> = new Map<string, any>() ;

  static Register(component: any, targetModule?, ...aliases: string[]) {
    this.RegisterName(component.name, component);
    aliases.forEach(alias => this.RegisterName(alias, component));
    if (targetModule) {
      targetModule['entryComponent'] = targetModule['entryComponents'] || [];
      targetModule['entryComponent'].push(component);
    }
  }



  static Resolve(componentName: string): any {
    return this.ComponentsStore.get(this.FormalizeName(componentName));
  }

  protected static RegisterName(name: string, component: any) {
    const formalizeName = this.FormalizeName(name);
    if (this.ComponentsStore.has(formalizeName)) {
      console.error('Resolvable component with name %s already exists for component %s, registration declined', formalizeName, component.name);
      return;
    }
    this.ComponentsStore.set(formalizeName, component);
  }

  private static FormalizeName(name) {
    return name.toUpperCase();
  }


}
